import { type ComponentPropsWithRef, type ReactNode } from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { formatBadgeCount } from "@vega-core/utils/formatBadgeCount";

type Props = ComponentPropsWithRef<"button"> & {
  icon: ReactNode;
  count: number;
  dataTestId: string;
};

export const CoInvestBadgeTriggerButton = ({
  icon,
  count,
  dataTestId,
  className,
  ...buttonProps
}: Props) => (
  <button
    {...buttonProps}
    className={cnTwMerge(
      "relative inline-flex items-center justify-center h-8 w-8 rounded-md text-text/primary hover:bg-icon-button/no-background/hover defaultTransition focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-default",
      className,
    )}
    data-testid={dataTestId}
    type="button"
  >
    {icon}
    {count > 0 ? (
      <span
        aria-hidden="true"
        className="absolute -top-1 -right-1 inline-flex items-center justify-center min-w-4.5 h-4.5 px-1 rounded-full bg-brand-default text-text/on-brand body-extra-small-semibold leading-none font-semibold ring-2 ring-background/primary"
        data-testid={`${dataTestId}-count`}
      >
        {formatBadgeCount(count)}
      </span>
    ) : null}
  </button>
);
